import * as React from 'react';
import * as Clients from '../../../client/ApiClient';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, Card, CardBody, CardText, CardTitle, Col, Container, Row } from 'reactstrap';
import DataListInput from '../DataListInput';
import { DataCell, DataRow, DataTable, DataTableButton } from '../DataTable';
import * as Roles from 'constants/Roles';
import UIControllerImageLoaderPage from './UIControllerImageLoader';
import UIControllerRunningExecutionsPage from './UIControllerRunningExecutions';
import { store } from '../../../AppContext';
import { enqueueNotification } from '../../../store/Notifications';
import { saveAs } from 'file-saver';
import { CardContent } from '@mui/material';
import * as SourceSystem from 'constants/SourceSystem';
import { ConversionTypeModel } from '../../../client/ApiClient';

interface IUIControllerPageState {
    controller: Clients.UIControllerModel | null;
    userList: Clients.UserModel[] | null;
    selected: string;
    conversionTypes: Clients.ConversionTypeModel[] | null;
}

class UIControllerPage extends React.Component<RouteComponentProps, IUIControllerPageState>{
    private readonly client: Clients.ConversionClient = new Clients.ConversionClient();
    private readonly users: Clients.UserClient = new Clients.UserClient();
    private conversionTypeClient: Clients.ConversionTypeClient = new Clients.ConversionTypeClient();

    constructor(props: Readonly<RouteComponentProps>) {
        super(props)
        this.state = {
            controller: null,
            selected: '',
            userList: null,
            conversionTypes: null,
        }
    }

    componentDidMount() {
        this.getConversionTypes()
        this.client.getUIController()
            .then(response => {
                this.setState({
                    controller: response!
                })
            })
            .catch(error => { console.log(error) });
    }

    update = <T extends keyof Clients.UIControllerModel>(type: T) => {
        const controller = Object.assign({}, this.state.controller)
        if (controller) {
            let message = '';
            if (type === 'addToMain') {
                controller.addToMain = !controller.addToMain
                message = controller.addToMain ? 'Add To Main - Merge On' : 'Add To Main - Merge Off'
            } else if (type === 'copyMapMerge') {
                controller.copyMapMerge = !controller.copyMapMerge
                message = controller.copyMapMerge ? 'Merge Copy Map On' : 'Merge Copy Map Off'
            } else if (type === 'addToMainEpic') {
                controller.addToMainEpic = !controller.addToMainEpic
                message = controller.addToMainEpic ? 'Add To Main - Epic On' : 'Add To Main - Epic Off'
            }
            this.setState({ controller }, () => {
                this.client.updateUIController(this.state.controller)
                    .then(() => store.dispatch(enqueueNotification({ type: 'success', message: message })))
                    .catch(error => {
                        console.log(error)
                    });
            })
        }
    }

    getConversionTypes = () => {
        this.conversionTypeClient.getAll()
            .then(response => {
                if (response !== null) {
                    if (response.length < 1) throw new Error('Source System Types list should not be empty.');
                    this.setState({
                        conversionTypes: response
                    })
                }
            })
            .catch(error => { });
    }

    conversionTypeToggle = (type: ConversionTypeModel) => {
        const active = !type.isActive
        const text = active ? 'On' : 'Off'

        const conversionTypes = this.state.conversionTypes!
        for (let i = 0; i < conversionTypes.length; i++) {
            if (conversionTypes[i].id === type.id) {
                conversionTypes[i].isActive = active
            }
        }

        this.conversionTypeClient.updateConversionTypeActive(type.id!, active)
            .then(() => this.setState({ conversionTypes }, () => {
                store.dispatch(enqueueNotification({ type: 'success', message: `${type.description} - ${text} ` }))
            }))
            .catch(error => {
                console.log(error)
            });
    }

    public render() {
        return (
            <>
                <Container>
                    <Row>
                        <Col xs="3">
                            <Card style={{
                                width: '16rem',
                                margin: '1%'
                            }}>
                                <CardBody>
                                    <CardTitle tag="h4">
                                        UI Controller
                                    </CardTitle>
                                    <CardText>
                                        <label className="switch"><input type="checkbox" checked={(this.state.controller && this.state.controller!.addToMain) || false} onChange={() => this.update('addToMain')} /> <span className="slider round"></span></label> Add To Main - Merge
                                    </CardText>
                                    <CardText>
                                        <label className="switch"><input type="checkbox" checked={(this.state.controller && this.state.controller!.addToMainEpic) || false} onChange={() => this.update('addToMainEpic')} /> <span className="slider round"></span></label> Add To Main - Epic
                                    </CardText>
                                    <CardText>
                                        <label className="switch">
                                            <input type="checkbox" checked={(this.state.controller && this.state.controller!.copyMapMerge) || false} onChange={() => this.update('copyMapMerge')} /> <span className="slider round"></span></label>
                                        Merge - Copy Map
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="3">
                        <Card style={{
                            width: '16rem',
                            margin: '1%'
                        }}>
                            <CardBody>
                                <CardTitle tag="h4">
                                    Conversion Type Controller
                                </CardTitle>
                                {this.state.conversionTypes && this.state.conversionTypes!.map(item => {
                                    return (
                                        <CardText>
                                            <label className="switch">
                                                <input type="checkbox"
                                                    id={item.id}
                                                    checked={(item.isActive) || false}
                                                    onChange={(e) => this.conversionTypeToggle(item)}
                                                    disabled={item.id!.toUpperCase() === SourceSystem.miniToAMS360Id || item.id!.toUpperCase() === SourceSystem.tamToAMS360Id} />
                                                <span className="slider round"></span>
                                            </label> {item.description}
                                        </CardText>)
                                })}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container >
            </>
        )
    }
}

export default withRouter(UIControllerPage)